import { Component, HostBinding, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { DialogAdapter } from "common/dialog/dialog-adapter";
import { WorkspaceSelected, WorkspaceSelectionComponent } from "common/workspace/workspace-selection.component";
import { TranslateModule } from "@ngx-translate/core";

export interface WorkspaceFilter {
	filterBy: string;
	filterParam1: string;
	filterParam2: string;
}

@Component({
	selector: "stages-workspace-selection-dialog",
	templateUrl: "./workspace-selection-dialog.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslateModule, WorkspaceSelectionComponent],
})
export class WorkspaceSelectionDialogComponent {
	private dialog = inject(DialogAdapter);

	@HostBinding("class.select-workspace-dialog") customClass = true;

	readonly filter = input.required<WorkspaceFilter>();

	dialogClosed(): void {
		this.dialog.close({
			value: "cancel",
		});
	}

	onSelectWorkspace(workspace: WorkspaceSelected): void {
		this.dialog.close({
			value: "ok",
			workspace: workspace,
		});
	}
}
